export const SECTION = {
  "Section.Bg.Color": {
    defaultValue: "Color.Transparent"
  },
  "Section.Header.Color": {
    ref: "Color.Gray.900"
  }
};
